// extracted by mini-css-extract-plugin
export var aiStarIcon = "_kc-2";
export var container = "_kc-4";
export var dismissButton = "_kc-3";
export var hasPaddingBottom = "_kc-6";
export var last = "_kc-e";
export var scrollbarThumb = "_kc-c";
export var scrollbarTrack = "_kc-b";
export var selected = "_kc-9";
export var spin = "_kc-1";
export var spinning = "_kc-0";
export var suggestionItem = "_kc-d";
export var suggestionsPanel = "_kc-5";
export var tonePill = "_kc-8";
export var tonesContainer = "_kc-7";
export var unselected = "_kc-a";